export class TagsInputsViewViewModel {
    constructor(props, state) {
        this.requiredFields = function () {
            const fieldValue = this.modalFieldValue();
            return ([
                {
                    id: "name",
                    label: "Name",
                    className: "name_text",
                    value: fieldValue.name
                },
                {
                    id: "url",
                    label: "URL",
                    className: "url_text",
                    value: fieldValue.url
                },
                {
                    id: "utmSource",
                    label: "Source",
                    className: "utm_source_text",
                    value: fieldValue.utmSource
                },
            ])
        }

        this.optionalFields = function () {
            const fieldValue = this.modalFieldValue();
            return ([
                {
                    id: "utmMedium",
                    label: "Medium (opt.)",
                    className: "utm_medium_text",
                    value: fieldValue.utmMedium
                },
                {
                    id: "utmCampaign",
                    label: "Campaign (opt.)",
                    className: "utm_campaign_text",
                    value: fieldValue.utmCampaign
                }
            ])
        }

        this.modalFieldValue = function () {
            let modalFieldValue = props.modalType === 'edit' ? state : '';
            return modalFieldValue
        }
    }
}
